<template>
  <div class="complete-page">
    <img src="@/assets/logo1.png" alt="MH13">
    <div class="mh-card form-card">
      <h1>Complete your profile</h1>
      <p>Please add these details to finish registration.</p>
      <label class="mh-form-label">Full name</label>
      <input v-model.trim="form.name" class="mh-form-control" autocomplete="name" placeholder="Your full name">
      <label class="mh-form-label">Date of birth</label>
      <input v-model="form.dob" class="mh-form-control" type="date" :max="today">
      <label class="terms"><input v-model="form.terms_accepted" type="checkbox"><span>I accept the Terms & Conditions and Privacy Policy.</span></label>
      <button class="mh-btn mh-btn-gold" @click="submit">Complete registration</button>
    </div>
  </div>
</template>
<script>
import api from "@/api";
export default {
  name:"CompleteProfile",
  data(){return{form:{name:"",dob:"",terms_accepted:false},today:new Date().toISOString().slice(0,10)}},
  mounted(){if(!localStorage.getItem("token"))this.$router.replace("/login")},
  methods:{async submit(){if(this.form.name.length<2||!this.form.dob||!this.form.terms_accepted)return this.$alert("Enter your name and date of birth, then accept the terms.","warning");try{await api.completeProfile(this.form);this.$alert("Registration completed","success");this.$router.replace(this.$route.query.next||"/")}catch(error){this.$alert(error.response?.data?.message||"Could not complete registration","error")}}}
};
</script>
<style scoped>.complete-page{min-height:100vh;padding:32px 18px;background:#f6f7f9}.complete-page>img{display:block;width:155px;height:90px;object-fit:contain;margin:0 auto 20px}.form-card{max-width:520px;margin:auto;padding:24px}.form-card h1{margin:0;font-size:24px}.form-card>p{color:#667085;margin-bottom:24px}.mh-form-label{margin-top:15px}.terms{display:flex;align-items:flex-start;gap:10px;margin:20px 0;color:#475467;font-size:13px;line-height:1.5}.terms input{margin-top:3px}.mh-btn{width:100%}</style>
